import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../shared/button/button";
import Services from "../../../../API/LegalFormService";
import { useLegalFormStepsContext } from "../../../../context/LegalFormContext";
import { SERVICE_TYPES } from "../../../../utils/constants/fieldErrors";
import { useGlobalContext } from "../../../../context/globalContext";
import { useHistory } from "react-router-dom";
import getData from "../../../../utils/helpers/getData";
import {
  AgreementContainer,
  DocumentLink,
} from "../../../common/styledComponents/agreementStyles/agreement.style";
import Loader from "../../../../shared/loaders/simpleLoader";
import { isContentGeorgian } from "../../../PIForm/Steps/step3/utils";
import { useLanguage } from "../../../../hooks/useLanguage";
import Conditions from "./Conditions";
import { ButtonWrapperStyles } from "../../../../shared/button/ButtonWrapperStyles";
export default function Step2Form() {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { catchError, setCountries } = useGlobalContext();
  const history = useHistory();
  const { contentLanguage } = useLanguage();
  const { setRedirectUrl, prevStep } = useLegalFormStepsContext();
  const { GetLegalCountries, getAuthLink } = Services;

  const handleConfirm = () => {
    if (!loading) {
      setLoading(true);
      getAuthLink(i18n.language, SERVICE_TYPES.Legal)
        .then((res) => {
          sessionStorage.setItem("localToken", res.data.localToken);
          sessionStorage.setItem("servicetype", SERVICE_TYPES.Legal);
          setRedirectUrl(res.data.redirectUrl);
          history.push(`/Legal/Identomat/${i18n.language}`);
          setLoading(false);
        })
        .catch((err) => catchError(err, { withoutRedirect: true }));
    }
  };

  const tariffsLink = useMemo(
    () =>
      isContentGeorgian(contentLanguage)
        ? "https://www.procreditbank.ge/sites/default/files/conditions/iurudiuli_piris_angarishis_gaxsnistvis_sachiro_sabutebis_sia_004_0.pdf?mid=1637"
        : "https://www.procreditbank.ge/sites/default/files/conditions/documents_eng_0.pdf?mid=1638",
    [contentLanguage]
  );
  useEffect(() => {
    GetLegalCountries().then(getData).then(setCountries).catch(catchError);
  }, []);
  return (
    <AgreementContainer>
      {loading ? (
        <Loader />
      ) : (
        <div className="agreementWrapper">
          <Conditions />
          <div className={"agreementTextWrapper"}>
            <p>
              <span>{t("checkDocuments")}</span>
              <DocumentLink
                href={tariffsLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("documents")}
              </DocumentLink>
              <span>{t("checkDocuments2")}</span>
            </p>
          </div>
          <div className={"agreementTextWrapper"}>
            <span>{t("accountOpening")}</span>
          </div>
          <ButtonWrapperStyles>
            <Button
              variant={"inherit"}
              onClick={prevStep}
              style={{ marginRight: "5px" }}
            >
              {t("prev")}
            </Button>
            <Button
              variant={loading ? "disabled" : "primary"}
              onClick={handleConfirm}
            >
              {t("next")}
            </Button>
          </ButtonWrapperStyles>
        </div>
      )}
    </AgreementContainer>
  );
}
